import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

import { desktopCSS } from '@measures/responsive'
import { RecentMatchOutcomesTeam } from '@hooks/useRecentMatchOutcomes'

import OutcomeData from './OutcomeData'

interface TeamOutcomesProps {
  team: RecentMatchOutcomesTeam
  singleCompetitor?: boolean
}

const StyledMatchOutcomesWrapper = styled.div<
  Pick<TeamOutcomesProps, 'singleCompetitor'>
>`
  ${({
    theme: {
      spacing: { spacing4, spacing8 },
      colors: { strokeWeak },
    },
    singleCompetitor,
  }) => css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: center;
    width: 100%;
    border-radius: ${spacing4};
    border: 1px solid ${strokeWeak};
    padding-bottom: ${spacing8};
    box-sizing: border-box;
    height: 100%;

    ${singleCompetitor &&
    css`
      padding-bottom: 0;
      justify-content: center;
    `}
  `}
`

const StyledTeamWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing12, spacing20 },
    },
  }) => css`
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: center;
    gap: ${spacing12};
    flex-direction: row-reverse;
    flex-wrap: wrap;
    height: 44px;
    overflow: hidden;

    ${desktopCSS(css`
      gap: ${spacing20};
    `)}
  `}
`

const StyledTeamAbbreviation = styled.div`
  ${({
    theme: {
      spacing: { spacing8, spacing12 },
      colors: { fillDefault },
      typography: {
        catchword: {
          medium2: { bundledCSS: medium2CatchwordCSS },
        },
      },
    },
  }) => css`
    position: relative;
    top: -${spacing8};
    background-color: ${fillDefault};
    padding: 0 ${spacing8};
    ${medium2CatchwordCSS};
    line-height: ${spacing12};
  `}
`

const TeamOutcomes: FunctionComponent<TeamOutcomesProps> = ({
  team,
  singleCompetitor = true,
}) => {
  return (
    <StyledMatchOutcomesWrapper singleCompetitor={singleCompetitor}>
      {!singleCompetitor && (
        <StyledTeamAbbreviation>{team.abbreviation}</StyledTeamAbbreviation>
      )}
      <StyledTeamWrapper>
        <OutcomeData team={team} />
      </StyledTeamWrapper>
    </StyledMatchOutcomesWrapper>
  )
}

export default TeamOutcomes
